export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(139, 92, 72, 0.85), rgba(101, 67, 56, 0.9)), url('https://public.readdy.ai/ai/img_res/c194df7c0381b5c55452bf7a55ac75d7.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl font-bold text-amber-50 mb-2" style={{ fontFamily: "'Pacifico', serif" }}>
            APEX
          </h1>
          <div className="w-32 h-1 bg-amber-300 mx-auto"></div>
        </div>
        
        <h2 className="text-3xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Connecting Exceptional Authors<br />With Engaged Book Clubs
        </h2>
        
        <p className="text-lg md:text-2xl text-amber-100 mb-12 max-w-3xl mx-auto leading-relaxed">
          A selective book promotion service matching standout titles with over 300 highly engaged online and in-person book clubs
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a 
            href="#request-slot" 
            className="whitespace-nowrap px-10 py-5 bg-amber-500 text-white text-lg font-semibold rounded-lg hover:bg-amber-600 transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer transform hover:scale-105"
          >
            Request a Slot
          </a>
          <a 
            href="#how-it-works" 
            className="whitespace-nowrap px-10 py-5 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer"
          >
            Learn How It Works
          </a>
        </div>
        
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-amber-300 mb-2">300+</div>
            <div className="text-white text-base md:text-lg">Active Book Clubs</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-amber-300 mb-2">Selective</div>
            <div className="text-white text-base md:text-lg">Curated Matches Only</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-amber-300 mb-2">Expert</div>
            <div className="text-white text-base md:text-lg">Professional Positioning</div>
          </div>
        </div>
      </div>
    </section>
  );
}
